module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_a-function.js
// module id = 25
// module chunks = 0 2 3 4 5 6 7 8 11 12 13 14 15 16 17 18 20